/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfDeviceDto } from '../../models/platform-api-result-of-device-dto';
import { PlatformUpdateDevice } from '../../models/platform-update-device';

export interface PutDevices$Params {
      body: PlatformUpdateDevice
}

export function putDevices(http: HttpClient, rootUrl: string, params: PutDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDeviceDto>> {
  const rb = new RequestBuilder(rootUrl, putDevices.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfDeviceDto>;
    })
  );
}

putDevices.PATH = '/api/devices';
